import React, { useState } from 'react'
import { ExportDataStyle } from './ExportData.style'
import jsPDF from 'jspdf'
import {utils,write} from "xlsx";
import { saveAs } from "file-saver";
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

const ExportData = ({title="data.pdf",style="export-div"}) => {
    const [isOpen, setIsOpen] = useState(false);
    const treeDataRed=useSelector(state=>state.treeDataRed)
    const toggleOptions = () => {
      setIsOpen(!isOpen);
    };
    const accountHeaders = [
        "Account Email",
        "Account Name",
        "Date Created",
    ];

    const baseStationHeaders=[
        "",
        "Gateway Name",
        "Gateway Status",
        "Gateay Location",
        "Gateway Firmware",
        "MAC Number"
    ]

    const beaconHeaders=[
        "",
        "",
        "Beacon Name",
        "Beacon Status",
        "Beacon Location",
        "Beacon Firmware",
        "MAC Number",
        "Battery"

    ]

    

    

    const downloadHtml2PDF=async()=>{
      try {  
        const treeData=treeDataRed.treeData
        // const data=JSON.parse(treeData)
        const data2=treeData[0].children
        const doc=new jsPDF()
        
        doc.text(100,10,"Ocufii Admin Portal",{align:"center"}).setFontSize(12).setFont("Helvetica","bold")
        doc.setFontSize(8)
        doc.setFont("Helvetica","normal")
        

        
        let y=20
        let page=1;
        data2.forEach((account,index) => {
            if(y===300){
              doc.addPage()
              page ++;
              doc.text(100,10,`Page ${page}`,{align:"center"}).setFontSize(12).setFont("Helvetica","bold")
              doc.setFontSize(8)
              doc.setFont("Helvetica","normal")
              y=20
            }
            doc.text(5,y,`${accountHeaders[0]}: ${account.email}, ${accountHeaders[1]}: ${account.name}, ${accountHeaders[2]}: ${account.date}`,{align:"justify"})  
            
            y+=10;
            const baseStationRecord=account.children
            if(baseStationRecord.length>0){
              baseStationRecord.forEach((baseStation,bSIndex) => {
                  if(y===300){
                    doc.addPage()
                    page ++;
                    doc.text(100,10,`Page ${page}`,{align:"center"}).setFontSize(12).setFont("Helvetica","bold")
                    doc.setFontSize(8)
                    doc.setFont("Helvetica","normal")
                    y=20
                  }
                  
                  doc.text(10,y,`Gateway Name: ${baseStation.name}, Status: ${baseStation.status}, Location: ${baseStation.location}, Firmware: ${baseStation.firmware}, MAC Number: ${baseStation.id}`,{align:"justify"})
                   
                  y+=10
                  const beaconRecord=baseStation.children
                  if(beaconRecord.length>0){      
                    beaconRecord.forEach((beacon,bIndex) => {
                      if(y===300){
                        doc.addPage()
                        page ++;
                        doc.text(100,10,`Page ${page}`,{align:"center"}).setFontSize(12).setFont("Helvetica","bold")
                        doc.setFontSize(8)
                        doc.setFont("Helvetica","normal")
                        y=20
                      }
                          
                      doc.text(15,y,`Beacon Name: ${beacon.name}, Status: ${beacon.status}, Location: ${beacon.location}, Firmware: ${beacon.firmware}, MAC Number: ${beacon.id}, Battery: ${beacon.batteryLevel}%`,{align:"justify"})
                      y+=10
                    });      
                  }
                });
            }
        });
        doc.save("OcufiiData.pdf")
      } catch (error) {
        toast.error("Error downloading PDF",{
          bodyClassName:"notification-div-error",
          progressClassName:"progress-bar-error"
        })
        
      }  
  
    }

    

    const downloadCSV=()=>{

        
        let csvContent="";
        const treeData=treeDataRed.treeData
        // const data=JSON.parse(treeData)
        const data2=treeData[0].children
        data2.forEach((account) => {
            csvContent += accountHeaders.join(",") + "\n";
            csvContent += `${account.email},${account.name},${account.date}\n`;
            csvContent += `\n`;
            account.children.forEach((baseStation) => {
                csvContent += baseStationHeaders.join(",") + "\n";

                csvContent += `,${baseStation.name}, ${baseStation.status}, ${baseStation.location},${baseStation.firmware},${baseStation.id}\n`;
                csvContent += `\n`;
                if(baseStation.children.length>0){
                    csvContent += beaconHeaders.join(",") + "\n";
                    baseStation.children.forEach((beacon) => {
                        csvContent += `,, ${beacon.name}, ${beacon.status}, ${beacon.location},${beacon.firmware},${beacon.macNumber},${beacon.batteryLevel}\n`;
                    });
                    csvContent += `\n`;
                }
                
            });
            
        });
        const csvData = new Blob([csvContent], { type: "text/csv;charset=utf-8," });
        
        saveAs(csvData, "OcufiiData.csv");


    }

    const downloadExcel=async()=>{
        const treeData=treeDataRed.treeData
        // const data=JSON.parse(treeData)
        const data2=treeData[0].children
        const workbook = utils.book_new();
        const sheetData = [];
        data2.forEach((account) => {
            sheetData.push(accountHeaders)
            sheetData.push([account.email,account.name,account.date]);
            sheetData.push([""])
            account?.children.forEach((baseStation) => {
                sheetData.push(baseStationHeaders)
                sheetData.push(["",baseStation.name, baseStation.status, baseStation.location,baseStation.firmware,baseStation.id]);
                sheetData.push([''])
                if(baseStation.children.length>0){
                    sheetData.push(beaconHeaders)
                    baseStation.children.forEach((beacon) => {
                        sheetData.push(["", "", beacon.name, beacon.status, beacon.location,beacon.firmware,beacon.macNumber,beacon.batteryLevel]);
                    });
                    sheetData.push([""])
                }
            });
        });
        
        const worksheet = utils.aoa_to_sheet(sheetData,{ cellStyles: true });
        utils.book_append_sheet(workbook, worksheet, "OcufiiData");
        const excelBuffer = write(workbook, { bookType: "xlsx", type: "array" });
        const excelData = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        saveAs(excelData, "OcufiiData.xlsx");

    }
  

  return (
    <ExportDataStyle>
        <div className={style}>
            <div className={isOpen?"options-container":"hide"}>
                <div className='download-div' title='Download PDF' onClick={downloadHtml2PDF}>
                    <i className="bi bi-file-earmark-pdf-fill download-icon"></i>
                </div>
                <div className='download-div' title='Download XLSX' onClick={downloadExcel}>
                <i className="bi bi-file-spreadsheet-fill download-icon" ></i>
                </div>
                <div className='download-div' title='Download CSV' onClick={downloadCSV}>
                    <i className="bi bi-filetype-csv download-icon" ></i>
                </div>
            </div>
            <div className='download-div' onClick={toggleOptions}>
                <i className={isOpen?"bi bi-cloud-download-fill download-icon-rotate":"bi bi-cloud-download-fill download-icon2"}></i>
            </div>
        </div>
    </ExportDataStyle>
  )
}

export default ExportData